import { Button, Dropdown, Flex, Nav } from '@wyz/ui';
import { LocaleUtils } from '@wyz/utils';
import { AutomakerLogoHolder, CountryFlag } from '~/common/components';
import { useLocale } from '~/common/context';
import { useManageLocale } from '~/common/hooks';

// eslint-disable-next-line @wyz/module/no-relative-import
import ProfileDropdown from './profile-dropdown';

const TopNavRightSideNavItem = () => {
  const { locale, country, languages } = useLocale();
  const { updateLocale } = useManageLocale();

  return (
    <Nav
      navbar
      className='navbar-nav-icons ms-auto flex-row align-items-center'
      as='ul'
    >
      <AutomakerLogoHolder />
      <Dropdown.Container>
        <Dropdown.Toggle bsPrefix='toggle' as='div' id='select-locale-toggler'>
          <Button
            id='select-locale'
            onClick={() => {}}
            variant='tertiary-blue'
            size='xs'
          >
            <Flex className='space-x-2' alignItems='center'>
              <CountryFlag countryCode={country} width={20} />
              <span className='text-nowrap'>
                {LocaleUtils.getHumanReadableLabel({
                  userLocale: locale,
                  locale: locale,
                  fallback: locale,
                })}
              </span>
            </Flex>
          </Button>
        </Dropdown.Toggle>

        <Dropdown.Menu className='dropdown-caret dropdown-menu-card dropdown-menu-end'>
          {languages.byIndex.map((language) => (
            <Dropdown.Item
              key={language.isoCode}
              as='button'
              type='button'
              className='fs-xs space-x-2'
              onClick={() => {
                updateLocale(language.isoCode);
              }}
              id={language.isoCode}
            >
              <CountryFlag
                countryCode={language.isoCode.split('-').at(1) ?? ''}
                width={20}
              />
              <span>{language.humanName}</span>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown.Container>

      <ProfileDropdown />
    </Nav>
  );
};

export default TopNavRightSideNavItem;
